import { Skeleton } from 'antd';
import styled from 'styled-components';
import { ProgressStatus } from 'api/project';
import { TaskStatusType } from 'api/status-updates';
import { status } from 'components/organisms/projects/project-list/constants';
import { ProductiveHeading03 } from 'components/styles';
import { ResourceSectionType } from 'data/documents';

export interface Props {
  commandName?: string;
  commandOptions?: {
    [key: string]: any;
  };
  type: ResourceSectionType;
}

export const Count = styled.p`
  ${ProductiveHeading03};
  margin-bottom: 0;
  display: flex;
  align-items: center;
  span {
    height: auto;
    margin-left: var(--spacing-04);
  }
`;

export const TaskListSkelton = styled(Skeleton)`
  &.ant-skeleton {
    padding-left: var(--spacing-05);
  }
  .ant-skeleton-content .ant-skeleton-paragraph > li {
    height: 4px;
  }
  .ant-skeleton-content .ant-skeleton-paragraph > li + li {
    margin-top: var(--spacing-04);
  }
  .ant-skeleton-content .ant-skeleton-paragraph {
    margin-bottom: 0;
  }
`;

const statusTypeNumberMap = {
  [TaskStatusType.Completed]: 3,
  [TaskStatusType.Blocked]: 4,
  [TaskStatusType.Overdue]: 7,
  [TaskStatusType.Upcoming]: 1,
};

export const getStatus = (stat: TaskStatusType): ProgressStatus => {
  return status[statusTypeNumberMap[stat]] || status[1];
};
